import { Typography } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';
import { MessageTypes } from 'store/declarations/enums/common/declaration-types';

type Props = {
    open: boolean;
    messageType: MessageTypes;
    onConfirm: () => void;
    onCancel: () => void;
};

const ConfirmDismissModal = ({ open, messageType, onConfirm, onCancel }: Props) => (
    <ConfirmationModal
        open={open}
        type="warning"
        icon={<ExclamationCircleOutlined />}
        title="Close Without Completing?"
        confirmButtonText="Close"
        cancelButtonText="Keep Completing"
        onConfirm={onConfirm}
        onCancel={onCancel}
        onClose={onCancel}
        content={
            <Typography.Text style={{ paddingInline: 16, paddingBottom: 16 }}>
                The fields will stay highlighted on the {messageType} form. You will not be asked for them here again.
            </Typography.Text>
        }
    />
);

export default ConfirmDismissModal;
